import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
export enum OrderEditingFormTab {
  ORDER_EDITS = 'order-edits',
  ADDRESS_VALIDATION = 'address-validation',
  SETTINGS = 'settings',
}
@Component({
  selector: 'order-editing-form',
  standalone: false,
  templateUrl: './order-editing-form.component.html',
  styleUrl: './order-editing-form.component.scss',
})
export class OrderEditingFormComponent implements OnInit {
  tabs = [
    {
      label: 'Settings',
      value: OrderEditingFormTab.SETTINGS,
    },
    {
      label: 'Order Edits',
      value: OrderEditingFormTab.ORDER_EDITS,
    },
    {
      label: 'Address Validation',
      value: OrderEditingFormTab.ADDRESS_VALIDATION,
    },
  ];
  OrderEditingFormTab = OrderEditingFormTab;
  activeTab = OrderEditingFormTab.SETTINGS;

  private destroyRef = inject(DestroyRef);
  constructor(public orderEditingService: OrderEditingService) {}

  ngOnInit(): void {
    this.orderEditingService.onSetTab$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((tab) => {
      this.activeTab = tab;
    });
  }

  onTabChange(event: any) {
    this.activeTab = event;
  }
}
